import { createContext } from '@chakra-ui/react-utils'
import { useForm as useReactHookForm } from 'react-hook-form'

const [FormProvider, useFormContext] = createContext({
  name: 'FormContext',
  errorMessage:
    'useFormContext: `context` is undefined. Seems you forgot to wrap the components in `<Form />`'
})

export const useForm = ({ isError = false, isLoading = false, data: defaultValues, ...rest }) => {
  const methods = useReactHookForm({ defaultValues, ...rest })

  return {
    ...methods,
    isError,
    isLoading
  }
}

export { FormProvider, useFormContext }
